class OwnContractModelServiceMapper {
  static createFromResponse(response) {
    return {
      id: response.id,
      name: response.name,
      isSelected: response.is_selected
    };
  }
}

export { OwnContractModelServiceMapper };
//# sourceMappingURL=OwnContractModelServiceMapper.js.map
